import http from 'util/http'
/**
 * 获取英雄榜列表
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 * @param {number} type 星级
 * @param {number} team 团队
 */
export function getList(
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
  type: number,
  team?: number,
) {
  return http.get('/newxyrj/public/hero/billboard/list', {
    pageindex,
    pagesize,
    type,
    team,
  })
}
/**
 * 获取年度英雄榜
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 * @param {number} type 6200101~6200105（顺序：领袖、职业经理人、金牌投顾、十佳精英、年度新人王）
 * @param {number} year 年份
 */
export function getYearList(
  { pageindex, pagesize = 9 }: { pageindex: number; pagesize?: number },
  type: number,
  year?: number,
) {
  return http.get('/newxyrj/public/year/hero/billboard/list', {
    pageindex,
    pagesize,
    type,
    year,
  })
}
/** 获取年度英雄榜 */
export function getYear() {
  return http.get('/newxyrj/public/hero/billboard/year', {})
}
